import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DataService } from "src/app/services/data.service";
import { POSearchResult, ShipSearchResult } from "src/app/models/search/search-results";
import { ShippingProductList } from "src/app/models/dashboard/shipping-error";


@Component({
  selector: 'app-po-search',
  templateUrl: './po-search.component.html',
  styleUrls: ['./po-search.component.scss']

})
export class PoSearchComponent implements OnInit {
  @Input() touched: boolean = false;
  @Input() valid: boolean = false;

  @Output() onSelect: Subject<POSearchResult> = new Subject();

  public searchCriteria: string;
  public results: Array<ShipSearchResult> = [];
  public activeIndex: number;
  private cancelSearch: Subject<any> = new Subject();
  public ProductString: string;
  public ShipNumber: string;
  public ShippingProducts: Array<ShippingProductList> = [];
  isLoading = false;
  selectedShippingProducts: any[] = [];
  @Output() productSelected = new EventEmitter<ShippingProductList>();


  productSearchTerm: string = '';
  productSortKey: string = 'code';


  constructor(private dataService: DataService) { this.ProductString = "";}
  ngOnInit(): void {  }

  search() {
    if (this.searchCriteria?.length > 2) {
      this.cancelSearch.next(null);
      this.dataService
        .searchShipping(this.searchCriteria)
        .pipe(takeUntil(this.cancelSearch))
        .subscribe((resp) => { this.results = resp; this.activeIndex = undefined; });
    } else {
      this.results = [];    
    }
  }

  clearProductSelection() {
    this.searchCriteria = ''; // ✅ clears PO search box
    this.productSearchTerm = ''; // clears product text search
    this.productSortKey = 'code'; // resets sort
    this.selectedShippingProducts = [];
    this.ShippingProducts = [];
    this.ShipNumber = '';
    this.results = [];

  }

  selectPO(result) {
    this.searchCriteria = result.shippingNumber;
    this.onSelect.next(result.shippingNumber);
    this.results = [];
    this.ProductString = "";
    this.selectedShippingProducts = [];

    this.dataService
      .searchShippingProds(result.shippingNumber)
      .subscribe((resp) => {
        this.ShippingProducts = resp;

        // Store for interactive UI
        this.selectedShippingProducts = resp.map(p => ({
          productCode: p.productCode,
          productQuantity: p.productQuantity,
          productDescription: p.productDescription,
          //imageUrl: p.imageUrl || null, // optional future use
          //serialRequired: p.serialRequired || false, // optional future use
          //price: p.price || null // optional future use
        }));

        // Still build ProductString if needed for logging/debug
        for (const prod of resp) {
          this.ProductString += `${prod.productCode} (${prod.productQuantity}) ${prod.productDescription}\n`;
        }
      });
  }


  get filteredSortedProducts() {
    let products = [...(this.selectedShippingProducts || [])];

    // Filter
    if (this.productSearchTerm?.trim()) {
      const term = this.productSearchTerm.toLowerCase();
      products = products.filter(p =>
        p.productCode?.toLowerCase().includes(term) ||
        p.productDescription?.toLowerCase().includes(term)
      );
    }

    // Sort
    products.sort((a, b) => {
      switch (this.productSortKey) {
        case 'description':
          return a.productDescription.localeCompare(b.productDescription);
        case 'quantity':
          return b.productQuantity - a.productQuantity;
        case 'code':
        default:
          return a.productCode.localeCompare(b.productCode);
      }
    });

    return products;
  }




  onKeyUp(e) {
   this.search();  
  }
  onKeyDown(e) {
    if (this.searchCriteria?.length > 0) {
      switch (e.keyCode) {
        case 38:     
          if (this.activeIndex) { this.activeIndex--; }
          this.scrollOptionIntoView('po-search_search_option_' + this.activeIndex)
          break;
        case 40:
          this.activeIndex === undefined ? this.activeIndex = 0 : this.activeIndex = Math.min(this.activeIndex + 1, this.results.length);
          this.scrollOptionIntoView('po-search_search_option_' + this.activeIndex)
          break;
        case 13:
          if (this.activeIndex) { this.selectPO(this.results[this.activeIndex]); }
          break;
      }
    }

  }


  addFromPO(product: ShippingProductList) {
    this.productSelected.emit(product);
  }



  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/placeholder.png';
  }

  scrollOptionIntoView(id) {
    //not implemented yet
  }

}
